// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ========= Copyright 2025-2026 @ Eigent.ai All Rights Reserved. =========

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// Only UI preferences live here. API keys and model parameters never enter storage.
type ModelVisibilityState = {
  hiddenByAccount: Record<string, string[]>;
  setHidden: (account: string, modelId: string, hidden: boolean) => void;
};
export const useModelVisibilityStore = create<ModelVisibilityState>()(
  persist(
    (set) => ({
      hiddenByAccount: {},
      setHidden: (account, modelId, hidden) =>
        set((state) => {
          const ids = state.hiddenByAccount[account] ?? [];
          return {
            hiddenByAccount: {
              ...state.hiddenByAccount,
              [account]: hidden
                ? [...new Set([...ids, modelId])]
                : ids.filter((id) => id !== modelId),
            },
          };
        }),
    }),
    { name: 'eigent-model-visibility-v1' }
  )
);
